export const getAcceptedFilesText = (formats: string[]): string =>
  `Accepted ${formats.join(", ")} files`;

export const isValidEmail = (value: string): boolean => {
  const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

  return !!String(value).match(EMAIL_REGEX);
};
